import { Component } from '@angular/core';

@Component({
  selector: 'pdf-add-signature-dialog',
  templateUrl: './pdf-add-signature-dialog.component.html',
  styleUrl: './pdf-add-signature-dialog.component.css',
})
export class AddSignatureDialogComponent {}
